import React from 'react';

import Image from 'marketing-website/components/modules/Image';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Spacing from '@marvelapp/marvel-ui/spacing';
import MarvelLink from '@marvelapp/marvel-ui/link';
import { InlineGrid } from '@marvelapp/marvel-ui/grid';

import Page from 'marketing-website/components/modules/Page';
import Whitespace from 'marketing-website/components/commons/Whitespace';

import assets from 'marketing-website/configs/pages/apps/assets.js';

import Features from './Features';

import styles from './style/general.module.css';

export default function Pop() {
  return (
    <Page
      title="Apps | Marvel"
      meta={[
        {
          name: 'description',
          content:
            'Design and Prototype on the iPhone, iPad, Apple Watch, Apple TV & Android in the palm of your hand',
        },
        { name: 'keywords', content: '' },
      ]}
      header
      footer
    >
      <div className="overflow-hidden">
        <div className={styles.wrap}>
          <Image {...assets.apps} />
          <MaxWidth value={720}>
            <h1 className={styles.heading}>
              Turn anything into interactive prototypes
            </h1>
          </MaxWidth>
          <Spacing size="l" type="padding" position="bottom">
            <MaxWidth value={720}>
              <p className={styles.subheading}>
                Our apps let you create, play and share on the go.
              </p>
            </MaxWidth>
          </Spacing>
          <InlineGrid startAfterS size="m" sizeS="m">
            <MarvelLink
              url="https://itunes.apple.com/us/app/marvel-app/id765801658?mt=8"
              target="_blank"
            >
              <Image {...assets.appStore} />
            </MarvelLink>
            <MarvelLink
              url="https://play.google.com/store/apps/details?id=com.marvelapp"
              target="_blank"
            >
              <Image {...assets.googlePlay} />
            </MarvelLink>
          </InlineGrid>
        </div>

        <Features />
        <Whitespace size="s" sizeS="l" sizeM="xl" />
      </div>
    </Page>
  );
}



// WEBPACK FOOTER //
// ./src/pages/apps/index.js